/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Embed_Captions_Local_Done_TextInputs */



/**
* | output |
* | --- |
* | "Files written: {count}" |
*
* @param {Embed_Captions_Local_Done_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_done_text = /** @type {((inputs: Embed_Captions_Local_Done_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Done_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Fichiers écrits : ${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Geschriebene Dateien: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`File scritti: ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Записанные файлы: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Archivos escritos: ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已写入文件：${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`書き込まれたファイル: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`लिखी गई फ़ाइलें: ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Arquivos gravados: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Files written: ${i?.count}`)
});